import * as THREE from '@blade-sxp/map/src/objects/three.js';
import { AnimationMixer, } from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
export var Model;
(function (Model) {
    Model["MALE"] = "male";
    Model["FEMALE"] = "female";
    Model["MALE1"] = "male1";
    Model["FEMALE1"] = "female1";
    Model["UNKNOWN"] = "unknown";
    Model["CAR"] = "car";
})(Model || (Model = {}));
export const modelUrlConfig = {
    [Model.MALE]: '/personGltf/Man00.gltf',
    [Model.FEMALE]: '/personGltf/girl00.gltf',
    [Model.MALE1]: '/personGltf/Man01.gltf',
    [Model.FEMALE1]: '/personGltf/girl01.gltf',
    [Model.UNKNOWN]: '/human.glb',
    [Model.CAR]: '/carGltf/雪弗兰科迈罗25.gltf',
};
export const getModelUrl = (type) => {
    return modelUrlConfig?.[type] || modelUrlConfig?.[Model.UNKNOWN];
};
export const loadeModel = (type) => {
    return new Promise((resolve, reject) => {
        const loader = new GLTFLoader();
        const instancePerson = {};
        const animation = {};
        const gltfUrl = getModelUrl(type);
        try {
            loader.load(gltfUrl, (gltf) => {
                // if(gender ===Gender.UNKNOWN ) {
                gltf.scene.traverse((object) => {
                    if (object.isMesh) {
                        // object.castShadow = true;
                        // object.material.translate = true;
                        // ((object as Mesh).material as MeshToonMaterial).color.set('#000000');
                        // const emissive  = ((object as Mesh).material as MeshToonMaterial).emissive;
                        object.material.transparent = false;
                        object.material.depthTest = true;
                        // ((object as Mesh).material as MeshToonMaterial).aoMapIntensity = 0; // 环境遮挡效果，默认为1环境遮挡效果的强度。默认值为1。零表示没有遮挡效果。
                        if (type === Model.UNKNOWN) {
                            object.material.emissive.set('rgb(0,0,0)');
                            object.material.emissiveIntensity = 0.8;
                        }
                        object.material.fog = false; // 材质是否受雾影响
                        // ((object as Mesh).material as MeshToonMaterial).shadowSide =THREE.DoubleSide; // 定义投影的面。
                        // ((object as Mesh).material as MeshToonMaterial).dithering = true; // 是否对颜色应用抖动以消除条带的外观。默认值为 false。
                    }
                });
                // }
                gltf.scene.position.set(0, 0, 0);
                const scene = gltf.scene;
                const animations = gltf.animations;
                const mixer = new AnimationMixer(scene);
                animations.map((clipAnimation) => {
                    const animationName = clipAnimation.name;
                    const action = mixer.clipAction(clipAnimation);
                    animation[animationName] = action;
                });
                resolve({
                    gltf,
                    scene,
                    animation,
                    animations,
                    modelType: type,
                    mixer
                });
            });
        }
        catch (er) {
            reject(er);
        }
    });
};
// 裁剪动画
export const clipAnimation = (mixer, animations, filter) => {
    const animation = {};
    animations.forEach(anm => {
        const name = anm.name.toLocaleLowerCase();
        const action = mixer.clipAction(anm);
        // THREE.AnimationUtils.makeClipAdditive(action);
        const filterName = filter.find(key => {
            return name.indexOf(key) !== -1;
        });
        const animationName = filterName || name;
        action && (animation[animationName] = action);
    });
    return animation;
};
// 获取模型大小
export const getModelSize = (scene) => {
    const box3 = new THREE.Box3();
    box3.expandByObject(scene);
    const v3 = new THREE.Vector3();
    const size = box3.getSize(v3);
    return size;
};
